"use strict";

exports.__esModule = true;
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
/**
 * Wraps the business logic of retrieve always updated URLSearchParams
 */
var useURLSearchParams = function useURLSearchParams() {
  var search = (0, react_router_dom_1.useLocation)().search;
  return (0, react_1.useMemo)(function () {
    return new URLSearchParams(search);
  }, [search]);
};
exports["default"] = useURLSearchParams;